import React from 'react';
import { GraphContainer, GraphTitle } from './styles';
import GraphComponent from './component';
import ExportComponent from './export';

function GraphContainerComponent({ metric, dates, noData, chargerMetrics, option, offset, isRealTime, isDemo }) {
  return (
    <GraphContainer>
      <GraphTitle>
        <span>
          {metric.title} {metric.units ? `(${metric.units})` : null}
        </span>
        <ExportComponent
          dates={dates}
          noData={noData}
          metric={metric}
          chargerMetrics={chargerMetrics}
          offset={offset}
          isRealTime={isRealTime}
          isDemo={isDemo}
        />
      </GraphTitle>

      <GraphComponent option={option} />
    </GraphContainer>
  );
}

export default GraphContainerComponent;
